<div
    class="btn-group "
    [ngClass]="class ?? 'btn-group-sm mr-2'"
>
    <div
        (click)="setView(ViewMode.LIST)"
        [ngClass]="view === ViewMode.LIST ? 'btn-primary' : 'btn-outline-primary'"
        class="btn"
        pTooltip="{{ 'common.list' | translate }}"
    >
        <fa-icon [icon]="['far', 'list']"></fa-icon>
    </div>
    <div
        (click)="setView(ViewMode.TABLE)"
        [ngClass]="view === ViewMode.TABLE ? 'btn-primary' : 'btn-outline-primary'"
        class="btn"
        pTooltip="{{ 'common.table' | translate }}"
    >
        <fa-icon [icon]="['far', 'table']"></fa-icon>
    </div>
</div>
